import { render, staticRenderFns } from "./ModerationDetailEdit.vue?vue&type=template&id=a270b968"
import script from "./ModerationDetailEdit.vue?vue&type=script&lang=js"
export * from "./ModerationDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports